const columnSet = [
  { label: '事業所ID', key: 'company_id', detail: true, default: true },
  { label: '事業所名', key: 'company_name', detail: true, default: true },
  { label: '所在地/都道府県', key: 'prefecture' },
  { label: '所在地/市区町村', key: 'city' },
  { label: '住所', key: 'company_place', default: true },
  { label: '設立年', key: 'established' },
  { label: '企業URL', key: 'company_url', url: true },
  { label: '出稿予算/当月', key: 'budget_current_month', spLabel: '出稿予算/当月', default: true },
  { label: '出稿予算/先月', key: 'budget_last_month' },
  { label: '出稿予算/3ヶ月', key: 'budget_last_quarter' },
  { label: '出稿予算/6ヶ月', key: 'budget_last_harf_year' },
  { label: '出稿予算/1年', key: 'budget_last_year' },
  { label: '出稿メディア履歴（中途）', key: 'published_recruit_media_name_year', multiple: true },
  { label: '出稿メディア履歴（AP）', key: 'published_ap_media_name_year', multiple: true },
  { label: '電話番号/当社調べ', key: 'company_manual_tel' },
  { label: '電話番号/総合判定', key: 'company_tel', spLabel: 'TEL', default: true },
  { label: '掲載状況（中途）', key: 'published_jobs_recruit_media_year' },
  { label: '掲載状況（AP）', key: 'published_jobs_ap_media_year' },
  { label: '求人一覧', key: 'master_url', masterUrl: true, default: true },
  { label: 'リスト登録日時', key: 'created_at', spLabel: '追加日時', default: true },
  { label: '更新日', key: 'updated_date', spLabel: '更新日', default: true },
]
const defaultKeys = columnSet.concat().filter(key => key.default).map(({ key }) => key)

export default {
  namespaced: true,

  state: {
    sorting: false,
    columns: [],
    displayedColumns: [],
  },
  mutations: {
    configure: (state, { columns, displayedColumns }) => {
      state.columns = columns
      state.displayedColumns = displayedColumns
    },
    clear: (state) => {
      state.sorting = false
      state.columns = []
      state.displayedColumns = []
    },
    sort: (state) => {
      state.sorting = !state.sorting
    },
    done: (state) => {
      state.sorting = false
    },
  },
  actions: {
    initialize ({ commit }, { displayedColumns, spMode }) {
      // 表示項目変更・並び替え は SP ではデザインの都合で無効
      if (displayedColumns && !spMode) {
        const prioritizeColumns = displayedColumns.map(d => columnSet.find(c => c.key === d))
        const otherColumns = columnSet.filter(c => displayedColumns.indexOf(c.key) < 0)
        const columns = prioritizeColumns.concat(otherColumns)
        commit('configure', { columns, displayedColumns })
      } else {
        commit('configure', { columns: columnSet.concat(), displayedColumns: defaultKeys })
      }
    },
    async configure ({ commit, dispatch }, { columns, displayedColumns }) {
      commit('configure', { columns, displayedColumns })
      await dispatch('persist', { displayedColumns })
    },
    async persist ({ dispatch }, { displayedColumns }) {
      try {
        await dispatch('user/updateCompanyDisplayedColumns', { displayedColumns }, { root: true })
      } catch (e) {
        return Promise.reject(e)
      }
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/company-table-configuration.js